// Import dependencies
import React from 'react';

// Import CSS & assets
import './Partners.css';
import logo_ec from '../../../assets/logo/logo_etonnantscreateurs.svg';
import logo_fpt from '../../../assets/logo/logo_frenchproptech.svg';
import logo_nexity from '../../../assets/logo/logo_nexity_startupstudio.svg';
import logo_batinfo_innovation from '../../../assets/logo/logo_batinfo_innovation.svg';
import logo_pepites_tech from '../../../assets/logo/logo_pepites_tech.svg';

const Partners = () => {
    return (
        <div className="landing__partners">
            <div className="landing__partners_container">
                <img src={logo_ec} alt="logo_ec" />
            </div>
            <div className="landing__partners_container">
                <img src={logo_fpt} alt="logo_fpt" />
            </div>
            <div className="landing__partners_container">
                <img src={logo_nexity} alt="logo_nexity" />
            </div>
            <div className="landing__partners_container">
                <img src={logo_batinfo_innovation} alt="logo_batinfo_innovation" />
            </div>
            <div className="landing__partners_container">
                <img src={logo_pepites_tech} alt="logo_pepites_tech" />
            </div>
        </div>
    );
};

export default Partners;